import api from "services/api";
import { getSecureLocalItem } from "utils/secureSessionStorage";

const getAuthConfig = async () => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };
};

// Get permissions
export const getPermissions = async () => {
  return api.get("/v1/api/get-permission-list");
};

// create role
export const createPermissions = async (permissionData) => {
  return api.post("/v1/api/create-permission", permissionData);
};
